import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "typeButton", "typeContainer", "hiddenInput" ]

  static values = {
    id: Number,
    type: String,
    systemDataId: Number
  }

  connect() {
    // console.log("Hello, Article Data Controller here!", this.element)

    if (this.idValue) {
      this.changeDataType(null, this.typeValue);
    }
  }

  changeDataType(event, data_type = null) {

    const type = event ? event.target.dataset.dataType : data_type;
    // console.log('changeDataType', type);

    if (event) {
      this.typeButtonTargets.forEach(elm => elm.classList.remove('active'));
      event.target.classList.add('active');
    }

    this.typeContainerTargets.forEach(elm => {
      elm.classList.remove('d-block');
      elm.classList.add('d-none');

      // the link type and text type both have a "source" input that is the text field
      // so we need to disable both of them when we change the type and
      // enable the one that is the correct type for the new data type
      let text_input_element = elm.querySelector('input[type="text"]');
      if(text_input_element) {
        text_input_element.disabled = true;
      }
    });

    const sourceContainer = this.containerTarget.querySelector(`.type-source-${type}`);
    sourceContainer.classList.remove('d-none');
    sourceContainer.classList.add('d-block');

    // enable the source input for the new data type IF the system data id is not set
    if (!this.systemDataIdValue) {
      let source_input_element = sourceContainer.querySelector('input[type="text"]');
      if(source_input_element) {
        source_input_element.disabled = false;
      }
    }

    this.hiddenInputTarget.value = type;

    // console.log('sourceContainer', sourceContainer);
  }

  cleanPastedContent(event) {
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the clipboard data
    let pasteData = (event.clipboardData || window.clipboardData).getData('text');

    // use the DOM parser to remove HTML for us
    let doc = new DOMParser().parseFromString(pasteData, 'text/html');
    pasteData = doc.body.textContent || "";

    // Modify the pasted content, e.g., trimming and uppercasing
    // pasteData = pasteData.trim().toUpperCase();  // Example modification

    // Insert the modified content using execCommand to preserve undo functionality
    // Yes, I know it deprecated, but according to my overlord ChatGPT its still the best way
    // to preserve undo functionality.
    if (document.queryCommandSupported('insertText')) {
      document.execCommand('insertText', false, pasteData);
    } else {
      // Fallback for browsers that do not support execCommand('insertText')
      const start = event.target.selectionStart;
      const end = event.target.selectionEnd;
      const currentValue = event.target.value;
      event.target.value = currentValue.slice(0, start) + pasteData + currentValue.slice(end);
      event.target.setSelectionRange(start + pasteData.length, start + pasteData.length);
    }
  }

}
